export default __webpack_public_path__ + "static/media/subscribe.871fd7eb.png";